import type { PriorAuthorization } from "@/src/models/documents/prior-authorization/prior-authorization";

export function isReferralAuthCompleteFields(params: {
  authorizationNumber: string;
  requestId?: string | null;
  startDate: string;
  endDate: string;
  numberOfServices: number | null | undefined;
}): boolean {
  const authorizationNumber = params.authorizationNumber.trim();
  const requestId = params.requestId?.trim() ?? "";
  const startDate = params.startDate.trim();
  const endDate = params.endDate.trim();
  const visits = params.numberOfServices;

  return Boolean(
    (authorizationNumber || requestId) &&
    startDate &&
    endDate &&
    typeof visits === "number" &&
    Number.isFinite(visits) &&
    visits > 0
  );
}

export function isPriorAuthorizationCompleteForReferralAuth(priorAuthorization: PriorAuthorization): boolean {
  return isReferralAuthCompleteFields({
    authorizationNumber: priorAuthorization.authorizationNumber ?? "",
    requestId: priorAuthorization.requestId,
    startDate: priorAuthorization.startDate ?? "",
    endDate: priorAuthorization.endDate ?? "",
    numberOfServices: priorAuthorization.numberOfServices,
  });
}
